// extracted by mini-css-extract-plugin
export default {"button":"_6CDrAk79rriK90IK9kL","white":"eh36lygb0SzsVAxwEWnF","green":"baDrOfXrTB_ibZNitmv6","red":"zboS2znc0mwKd0t418Kg","disabled":"uPZnyuNfQwsX9O2MvODD"};